import { createWithI18n } from '@post-office/placement-common-v2/i18n';
import {messagesLoader as growthStarburst} from '@post-office/team-package--i18n--growth-starburst';

export const withI18n = createWithI18n(growthStarburst);